"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TasksService = void 0;
const api_1 = require("../api");
class TasksService {
    constructor(fetch) {
        this.apiVersion = api_1.apiVersion;
        this.fetch = fetch;
    }
    /**
     * Get available task sizes.
     * @returns {TaskSizes} A description of available task sizes.
     * @returns Error An error has occurred.
     * @throws ApiError
     */
    getTasks() {
        return this.fetch(`/${this.apiVersion}/tasks/sizes`, {
            method: "GET",
        });
    }
}
exports.TasksService = TasksService;
